var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"homepage"},[_c('div',{staticClass:"homepage__video-load",class:{ show: _vm.showVideoLoad }}),(_vm.getUIType() === 'small')?_c('ui-small'):_vm._e(),(_vm.getUIType() === 'large')?_c('ui-large'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }